import { useAuth } from '@hourly/contexts/AuthContext';
import { Button, ButtonSize } from '@hourly-hds/components';
import { CheckCircle } from '@hourly-hds/icons/colored';
import { useNavigate } from 'react-router';
import StepLayout from '../_shared/StepLayout';
import styles from './Completed.module.css';

interface CompletedProps {
  allowGoToPortal: boolean;
}

const Completed = ({ allowGoToPortal }: CompletedProps) => {
  const { updateSessionState } = useAuth();
  const navigate = useNavigate();

  const handleGoToPortal = () => {
    updateSessionState({ isInOnboarding: false });
    navigate('/', { replace: true });
  };

  return (
    <StepLayout>
      <div className={styles.container}>
        <CheckCircle className={styles.icon} color="#4cd964" />
        <StepLayout.Header>
          <StepLayout.Title>All Set</StepLayout.Title>
          <StepLayout.Description>Let&apos;s win some customers together</StepLayout.Description>
        </StepLayout.Header>
        {allowGoToPortal && (
          <StepLayout.Actions>
            <Button label="Go to Portal" size={ButtonSize.Large} onClick={handleGoToPortal} />
          </StepLayout.Actions>
        )}
      </div>
    </StepLayout>
  );
};

export default Completed;
